import { postRequest } from 'servos/apiRequests'

export const postMessage = (data, onSuccess, onFailure) => {
  let url = '/contact.json'
  postRequest({ url, data, onSuccess, onFailure })
}
